module.exports = __webpack_public_path__ + "static/media/closeHover.f0445efe.svg";